module.exports = __webpack_public_path__ + "img/GroupN2.bfef5035.png";